import React from 'react';
import { usePagination } from '@material-ui/lab/Pagination';
import { TablePaginationStyled, useTablePaginationStyles } from './styles';
import { getPageCount } from './helper';

type TablePaginationProps = {
  totalRecords: number;
  rowsPerPage: number;
  currentPage: number;
  onChangePage: (pageNumber: number) => void;
};

const TablePagination: React.FC<TablePaginationProps> = ({
  totalRecords,
  rowsPerPage,
  currentPage,
  onChangePage,
}) => {
  const classes = useTablePaginationStyles();
  const { items } = usePagination({
    count: getPageCount(rowsPerPage, totalRecords),
    onChange: (event, newPage) => onChangePage(newPage),
    page: currentPage,
  });

  return (
    <TablePaginationStyled>
      <ul className={classes.pageList}>
        {items.map(({ page, type, selected, ...item }, index) => {
          let children = null;

          if (type === 'start-ellipsis' || type === 'end-ellipsis') {
            children = '…';
          } else if (type === 'page') {
            children = (
              <button
                type="button"
                className={`${classes.pageButton} ${selected ? 'selected' : ''}`}
                {...item}
              >
                {page}
              </button>
            );
          } else {
            children = (
              <button type="button" {...item} className={classes.arrowButton}>
                {type}
              </button>
            );
          }

          return (
            <li key={index} className={classes.pageListItem}>
              {children}
            </li>
          );
        })}
      </ul>
    </TablePaginationStyled>
  );
};

export default TablePagination;
